import React from 'react';
import { InlineInputCardWrapper } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/shared/shared';
import { NumberUnitInput } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/shared/number-unit-input';

export interface GenericJsNumberInputProps {
  value: string;
  onChange: (value: string) => void;
}

export function GenericJsNumberInput({
  value,
  onChange,
}: GenericJsNumberInputProps) {
  return (
    <InlineInputCardWrapper>
      <span>Number Input</span>
      <NumberUnitInput noUnit initialValue={value} onChange={onChange} />
    </InlineInputCardWrapper>
  );
}
